import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { HeroJoinType } from "../../models/hero-join.model";
import { retrieveHeroJoin } from "../../redux/slice/hero-join.slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { retrieveSlider } from "../../redux/slice/slider-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const settingsTestimonial = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
};

const settingsSponsors = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Convergence2023Home = () => {
  const path = "Convergence-2023%2FHome";
  const memberSliderPath  = `%2F${path}%2FMemberSlider`;
  const sponsorSliderPath = `%2F${path}%2FSponsorSlider`;
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const { SliderData } = useSelector((state: RootState) => state.Slider);
  const { loading: heroJoinLoading, data: heroJoinData } = useSelector((state: RootState) => state.heroJoin);

  const [sliderHtmlString, setSliderHtmlString] = useState([] as HeroJoinType[]);
  const sliderRef = React.useRef<Slider>(null);

  const pause = () => {
    sliderRef.current?.slickPause();
  };

  const play = () => {
    sliderRef.current?.slickPlay();
  };

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveSlider(`${sponsorSliderPath}`));
    dispatch(retrieveHeroJoin(`${memberSliderPath}`));
  }, [dispatch]);

  useEffect(() => {
    if (!heroJoinLoading && heroJoinData?.data) {
      setSliderHtmlString(heroJoinData.data);
    }
  }, [heroJoinData]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-home-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023HomeStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
      <div className="container-sm blue-bg hero convergence">
        <Slider className="cursor-grab" {...settingsTestimonial} ref={sliderRef}>
          {sliderHtmlString.map((item, index) => {
            let isYoutube = item.media.includes("youtube");
            return (
              <div key={index} className="carousel-cell">
                <div className="row">
                  {isYoutube ? (
                    <>
                      <ReactPlayer url={item.media} height={315} width={560} className="col-md-6 youtube" onStart={pause} onPlay={pause} onPause={play} onEnded={play} />
                    </>
                  ) : (
                    <div className="col-md-6 media">
                      <img src={item.media} alt="" className="img-fluid heroimg" />
                    </div>
                  )}
                  <div className="col-md-6 content" dangerouslySetInnerHTML={{ __html: item.content }}></div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      <div>&nbsp;</div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.councilDescription }}></div>
      <div className="container hero convergence">
        <div className="gallery">
          <Slider className="cursor-hand" {...settingsSponsors}>
            {SliderData[0]?.sliderItemsList?.map((item, index) => {
              return <div key={index} dangerouslySetInnerHTML={{ __html: item.sliderContents }}></div>;
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Convergence2023Home;

const Convergence2023HomeStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .blue-bg.hero {
            background-color: #6EB9E0 !important
          }
        `}
      </style>
    </>
  );
};
